import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx } from "vue"
import _imports_0 from '@/app/ui/assets/svg/x-circle.svg'


const _hoisted_1 = { class: "flex flex-col h-full" }
const _hoisted_2 = {
  key: 0,
  class: "w-full h-full flex items-center justify-center relative"
}
const _hoisted_3 = {
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_4 = /*#__PURE__*/_createVNode("path", {
  d: "M24.0257 8.16V0L36 12H28.0171C24.4248 12 23.8593 9.44 24.0257 8.16Z",
  fill: "white",
  "fill-opacity": "0.3"
}, null, -1)
const _hoisted_5 = { key: 1 }
const _hoisted_6 = {
  key: 0,
  class: "w-full h-full flex items-center justify-center relative"
}
const _hoisted_7 = { class: "absolute bottom-2 right-2 bg-black bg-opacity-50 text-white px-2 py-1 rounded text-xs" }
const _hoisted_8 = { class: "absolute transform top-1/2 -translate-y-1/2 left-1/2 -translate-x-1/2" }
const _hoisted_9 = { class: "flex flex-col mt-1" }
const _hoisted_10 = {
  key: 0,
  class: "text-center text-sm"
}
const _hoisted_11 = {
  key: 1,
  class: "w-full flex justify-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icons = _resolveComponent("Icons")!
  const _component_ImagePreview = _resolveComponent("ImagePreview")!
  const _component_card = _resolveComponent("card")!

  return (_openBlock(), _createBlock(_component_card, {
    class: ["px-2 py-1 relative", { 'bg-gray-lp-1000': _ctx.disabled }],
    style: {"width":"120px","height":"158px"}
  }, {
    default: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        (_ctx.modelValue || _ctx.defaultImage)
          ? (_openBlock(), _createBlock("div", {
              key: 0,
              class: "flex-grow w-full overflow-hidden relative",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onPreview && _ctx.onPreview(...args)))
            }, [
              (_ctx.previewFileData.type && !_ctx.previewFileData.isVideo)
                ? (_openBlock(), _createBlock("div", _hoisted_2, [
                    (_openBlock(), _createBlock("svg", _hoisted_3, [
                      _createVNode("path", {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M9.69462 0H24L36 12V34.7926C36 37.6711 33.5088 40 30.4403 40H9.57031C6.49114 40 4 37.6711 4 34.7926V5.20733C3.99995 2.32878 6.61539 0 9.69462 0Z",
                        fill: _ctx.previewFileData.color
                      }, null, 8, ["fill"]),
                      _hoisted_4
                    ])),
                    _createVNode("span", {
                      class: ["font-bold text-base absolute bottom-3 transform left-1/2 -translate-x-1/2", { 'text-white': !_ctx.previewFileData?.text }],
                      style: `color: ${_ctx.previewFileData?.text}`
                    }, _toDisplayString(_ctx.previewFileData.type), 7)
                  ]))
                : (_openBlock(), _createBlock("div", _hoisted_5, [
                    (_ctx.previewFileData.isVideo)
                      ? (_openBlock(), _createBlock("div", _hoisted_6, [
                          _createVNode("img", {
                            src: _ctx.videoThumbnail,
                            class: "w-full object-cover flex-grow overflow-hidden rounded-md",
                            style: {"height":"110px"},
                            alt: "video-thumbnail"
                          }, null, 8, ["src"]),
                          _createVNode("div", _hoisted_7, _toDisplayString(_ctx.videoDuration), 1)
                        ]))
                      : (_openBlock(), _createBlock("img", {
                          key: 1,
                          src: _ctx.originalFile || _ctx.defaultImage,
                          class: "w-full object-cover flex-grow overflow-hidden rounded-md",
                          style: {"height":"110px"},
                          alt: "result-image"
                        }, null, 8, ["src"]))
                  ])),
              _createVNode("div", _hoisted_8, [
                _createVNode(_component_Icons, {
                  onClick: _ctx.setDefault,
                  name: "white-trash",
                  class: "w-5 text-gray-lp-600 cursor-pointer"
                }, null, 8, ["onClick"])
              ])
            ]))
          : (_openBlock(), _createBlock("div", {
              key: 1,
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.disabled ? null : _ctx.$refs.file.click())),
              onDragover: _cache[3] || (_cache[3] = (e) => _ctx.setDragAndDrop(e, true)),
              onDragleave: _cache[4] || (_cache[4] = (e) => _ctx.setDragAndDrop(e, false)),
              onDrop: _cache[5] || (_cache[5] = (e) => _ctx.onSubmitDrag(e)),
              class: 
          `h-full flex-grow overflow-hidden flex justify-center ${
            _ctx.disabled ? 'cursor-not-allowed' : 'cursor-pointer'
          } items-center text-12px border-2 border-dashed rounded-lg p-8 ${
            _ctx.isDragFile
              ? 'border-gray-lp-600 bg-gray-lp-100'
              : _ctx.erroreMessage
              ? 'border-red-lp-1000'
              : 'border-gray-lp-400'
          }`
        
            }, [
              _createVNode(_component_Icons, {
                class: !_ctx.erroreMessage ? 'text-gray-lp-600' : 'text-red-lp-1000',
                name: _ctx.icon
              }, null, 8, ["class", "name"])
            ], 34)),
        _createVNode("input", {
          id: String(_ctx.$attrs.id),
          type: "file",
          ref: "file",
          onChange: _cache[6] || (_cache[6] = (e) => (_ctx.isDragFile ? _ctx.onSubmitDrag(e) : _ctx.onSubmitClick(e))),
          accept: _ctx.accept,
          class: "hidden",
          multiple: ""
        }, null, 40, ["id", "accept"]),
        _createVNode("div", _hoisted_9, [
          _withDirectives(_createVNode("p", { class: "text-12px text-red-lp-1000" }, _toDisplayString(_ctx.erroreMessage), 513), [
            [_vShow, _ctx.erroreMessage]
          ]),
          (_ctx.title)
            ? (_openBlock(), _createBlock("div", _hoisted_10, _toDisplayString(_ctx.title), 1))
            : _createCommentVNode("", true),
          (_ctx.modelValue || _ctx.defaultImage)
            ? (_openBlock(), _createBlock("div", _hoisted_11, [
                _createVNode("button", {
                  type: "button",
                  class: "text-red-lp-100 underline text-10px cursor-pointer",
                  onClick: _cache[7] || (_cache[7] = () => _ctx.previewFileData.action())
                }, _toDisplayString(_ctx.previewFileData.actionLabel), 1)
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      (_ctx.showImagePreview && _ctx.modelValue)
        ? (_openBlock(), _createBlock(_component_ImagePreview, {
            key: 0,
            title: "Lampiran",
            images: _ctx.images,
            "title-images": _ctx.imageNames,
            "initial-index": _ctx.selectedImage,
            onClose: _ctx.closeImagePreview
          }, null, 8, ["images", "title-images", "initial-index", "onClose"]))
        : _createCommentVNode("", true),
      (_ctx.showDeleteIcon)
        ? (_openBlock(), _createBlock("img", {
            key: 1,
            src: _imports_0,
            class: "absolute w-5 top-0 right-0 cursor-pointer",
            alt: "x-circle",
            onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.onDeleteImage && _ctx.onDeleteImage(...args)))
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["class"]))
}